type LogLevel = 'debug' | 'info' | 'warn' | 'error'

interface LogData {
  [key: string]: unknown
}

const isDev = process.env.NODE_ENV === 'development'

const formatMessage = (level: LogLevel, message: string, data?: LogData): string => {
  const timestamp = new Date().toISOString()
  const dataStr = data ? ` ${JSON.stringify(data)}` : ''
  return `[${timestamp}] [${level.toUpperCase()}] ${message}${dataStr}`
}

const logger = {
  debug: (message: string, data?: LogData): void => {
    if (isDev) {
      console.debug(formatMessage('debug', message, data))
    }
  },

  info: (message: string, data?: LogData): void => {
    console.info(formatMessage('info', message, data))
  },

  warn: (message: string, data?: LogData): void => {
    console.warn(formatMessage('warn', message, data))
  },

  error: (message: string, error?: unknown, data?: LogData): void => {
    const errorData: LogData = { ...data }

    if (error instanceof Error) {
      errorData.errorMessage = error.message
      errorData.errorStack = error.stack
      errorData.errorName = error.name
    } else if (error) {
      errorData.error = error
    }

    console.error(formatMessage('error', message, errorData))
  },

  api: {
    request: (method: string, url: string, data?: LogData): void => {
      logger.debug(`API Request: ${method.toUpperCase()} ${url}`, data)
    },

    response: (method: string, url: string, status: number, duration?: number): void => {
      const data: LogData = { status }
      if (duration !== undefined) {
        data.duration = `${duration}ms`
      }
      logger.debug(`API Response: ${method.toUpperCase()} ${url}`, data)
    },

    error: (method: string, url: string, status: number | undefined, error: unknown): void => {
      logger.error(`API Error: ${method.toUpperCase()} ${url}`, error, { status })
    },
  },
}

export default logger
